export const chooseErrorMessage = (message = '') =>
  Array.isArray(message) ? message?.[0] : message;
